import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { SimCardAlertOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { simHaveProblem } from 'console/sim/utils/sim-problem';
import { getSimLink } from 'console/sim/utils/select-sim';
import { useNavigateTo } from 'shared/hooks/router';
export const SimProblem = memo(function SimProblem(props) {
    const { node, ...rest } = props;
    const sim_problem = usePartialAppSelector(simHaveProblem, node.device.id);
    const sim_link = usePartialAppSelector(getSimLink, node.device.id);
    const onClickSimProblem = useNavigateTo(sim_link);
    if (!sim_problem) {
        return null;
    }
    return (_jsx(Tooltip, { title: `Сим-карта ${sim_problem}`, children: _jsx(CustomIcon, { Icon: SimCardAlertOutlined, color: "error", onClick: onClickSimProblem, ...rest }) }));
});
